import React from 'react'

const formatSize = (size?: number) =>
  size === undefined ? '' : `${(size / (1024 * 1024)).toFixed(1)} MB`

export const SupportDiagnostics: React.FC<{
  diagnostics: Api_Chat.SupportDiagnostics
}> = ({ diagnostics }) => {
  if (diagnostics.error) {
    return (
      <div className="has-text-danger is-size-7">
        Diagnostics failed: {diagnostics.error}
      </div>
    )
  }
  const medias = diagnostics.unsyncedMedias ?? []
  const operations = diagnostics.pendingOperations ?? []
  const unreadableCount = medias.filter((media) => !media.readable).length
  const parkedCount = operations.filter((op) => op.parked).length

  return (
    <details className="is-size-7" style={{ marginTop: 4 }}>
      <summary>
        {diagnostics.unsyncedMediaCount ?? 0} unsynced media ({unreadableCount}{' '}
        unreadable) · {diagnostics.pendingOperationCount ?? 0} pending
        operations ({parkedCount} parked) · photo permission:{' '}
        {diagnostics.photoLibraryPermission ?? 'unknown'}
        {diagnostics.probeBudgetExceeded
          ? ` · only ${medias.length} media checked (time budget exceeded)`
          : ''}
      </summary>
      {medias.length > 0 && (
        <table className="table is-narrow is-fullwidth is-size-7">
          <thead>
            <tr>
              <th>Catch</th>
              <th>Media</th>
              <th>Readable</th>
              <th>Error</th>
            </tr>
          </thead>
          <tbody>
            {medias.map((media) => (
              <tr key={`${media.catchId}-${media.uri}`}>
                <td>
                  {media.catchServerId ?? `${media.catchId} (not on server)`}
                  {media.isDraft ? ' · draft' : ''}
                </td>
                <td style={{ wordBreak: 'break-all' }}>
                  {media.kind} · {media.uri}
                </td>
                <td
                  className={
                    media.readable ? 'has-text-success' : 'has-text-danger'
                  }>
                  {media.readable ? `yes ${formatSize(media.size)}` : 'no'}
                </td>
                <td style={{ wordBreak: 'break-all' }}>{media.error}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {operations.length > 0 && (
        <table className="table is-narrow is-fullwidth is-size-7">
          <thead>
            <tr>
              <th>Operation</th>
              <th>Retries</th>
              <th>Last error</th>
            </tr>
          </thead>
          <tbody>
            {operations.map((op) => (
              <tr key={`${op.entityType}-${op.entityId}-${op.createdAt}`}>
                <td>
                  {op.entityType}/{op.opType} · {op.entityId}
                </td>
                <td>
                  {op.retryCount}
                  {op.parked ? ' · parked' : ''}
                </td>
                <td style={{ wordBreak: 'break-all' }}>{op.lastError}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </details>
  )
}
